import React from "react";

import ListViewRowActions from "components/UserCardList/components/UserTableListView/ListViewRowActions";
import { Status } from "components/UserCardList/components/UserCardResult/molecules";

const HeaderPanel = ({ hit, activeTabName, collectionKey }) => {
  const panelOptions = [
    <Status
      key="status"
      matchStatus={
        hit?.match?.applicationId
          ? hit.match?.status
          : hit.associatedMatch?.status
      }
    />,
    <Status
      key="subStatus"
      matchStatus={
        hit?.match?.applicationId
          ? hit.match?.subStatus
          : hit.associatedMatch?.subStatus
      }
    />,
  ].filter(Boolean);

  return (
    <div className="flex items-center gap-3">
      {panelOptions.map((panelOption, index) => (
        <React.Fragment key={panelOption.key ?? index}>
          {panelOption}
          {index > 0 && index !== panelOptions.length - 1 && (
            <div className="w-px self-stretch bg-[#CBD5E1]" />
          )}
        </React.Fragment>
      ))}

      <ListViewRowActions
        hit={hit}
        row={{ original: hit }}
        activeTabName={activeTabName}
        collectionKey={collectionKey}
        tabUsesMatches={collectionKey === "match"}
        showFullProfileMenuItem
      />
    </div>
  );
};

export default HeaderPanel;
